<template>
  <div class="content">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex"></div>
      <div class="top-button-group">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mr-2" x-small right color="primary" @click="addUser">
              <v-icon small>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('common.add') }}</span>
        </v-tooltip>
      </div>
    </v-card>
    <v-data-table :headers="headers" :items="users" item-key="username" :loading="loading" class="elevation-1 content" fixed-header disable-pagination dense hide-default-footer height="700px">
      <template v-slot:item.actions="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" color="primary" @click="editUser(item)">mdi-pencil-box-multiple-outline</v-icon>
          </template>
          <span>{{ $t('common.edit') }}</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small color="primary" @click="deleteUser(item)">mdi-trash-can-outline</v-icon>
          </template>
          <span>{{ $t('common.delete') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <UserForm :userId="username" v-model="showUserForm" @change="onChange" />
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import UserForm from './UserForm';

export default {
  components: {
    UserForm,
  },
  data() {
    return {
      username: '',
      loading: false,
      showUserForm: false,
      users: [],
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
    headers() {
      return [
        { text: this.$t('user.id'), value: 'username', width: '5%', sortable: false },
        { text: this.$t('user.name'), value: 'name', width: '10%', sortable: false },
        { text: this.$t('user.email'), value: 'email', width: '20%', sortable: false },
        { text: this.$t('user.phoneNumber'), value: 'cellPhoneNumber', width: '10%', sortable: false },
        { text: this.$t('common.language'), value: 'language', width: '10%', sortable: false },
        { text: this.$t('user.timeZone'), value: 'timeZoneId', width: '10%', sortable: false },
        { text: this.$t('user.role'), value: 'role', width: '10%', sortable: false },
        { text: this.$t('user.montoringSystem'), value: 'targetMonitoringSystemIds', width: '10%', sortable: false },
        { text: this.$t('user.defaultSystem'), value: 'defaultTargetMonitoringSystemId', width: '5%', sortable: false },
        { text: '', value: 'actions', width: '80px', sortable: false },
      ];
    },
  },
  methods: {
    addUser() {
      this.username = '';
      this.openForm();
    },
    editUser(user) {
      this.username = user.username;
      this.openForm();
    },
    async deleteUser(user) {
      const result = await this.$dialog.confirm(this.$t('common.delete.q'));
      if (result) {
        this.startLoading();
        const { status } = await api.delete(`/preference/users/${user.username}`);
        if (status === 200) {
          this.onChange(user, true);
        }
        this.finishLoading();
      }
    },
    onChange(user, deleted) {
      const index = this.users.findIndex(u => u.username === user.username);
      if (deleted) {
        this.users.splice(index, 1);
      } else {
        if (index > -1) {
          Object.assign(this.users[index], user);
        } else {
          this.users.push(user);
        }
      }
    },
    openForm() {
      this.showUserForm = true;
    },
    startLoading() {
      this.loading = true;
    },
    finishLoading() {
      this.loading = false;
    },
  },
  async created() {
    this.startLoading();
    ({ data: this.users } = await api.get('/preference/users'));
    this.finishLoading();
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 950px;
  height: 700px;
}
</style>
